import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum PaymentErrorActions {
  SET_PAYMENT_ERROR = '@APP/SET_PAYMENT_ERROR'
}

export const INITIAL_PAYMENT_ERROR_STATE: string = '';

const paymentErrorSlice = createSlice({
  name: PaymentErrorActions.SET_PAYMENT_ERROR,
  initialState: INITIAL_PAYMENT_ERROR_STATE,
  reducers: {
    setPaymentError: (state, action: PayloadAction<string>) => {
      if (action.payload) {
        return action.payload;
      }
      return state;
    }
  }
});

export const { setPaymentError } = paymentErrorSlice.actions;

export const paymentErrorReducer = paymentErrorSlice.reducer;
